import Alpine from 'alpinejs';
import { AutocompleteResult, SimpleAutocompleteResult } from "../autocomplete/types";
import { isAppointmentForm } from "../autocomplete/helpers";
import { City, storeLocatorAutocomplete } from '../../scripts/helpers/storeLocator';
import {
    removeUserShop,
    setUserDataLocalisation,
    setUserDataShop
} from '../../helpers/user'
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';

const publicProperties: Record<string, any> = {
    results: [],
    nbInputs: null,
    displayResultsWording: false,
    noResults: false,
    tooShort: false,
    tooLong: false,
    modal: false,
    loading: false,
}

document.addEventListener('alpine:init', () => {
    Alpine.data('simpleAutocomplete', (): AlpineComponentTryba => {
        return {
            ...publicProperties,
            //Make api call with inputs and check if there are errors
            validateInput(event: any) {
                const targetValue = event.target.value.trim();
                if (targetValue !== '' && event.keyCode !== 13) {
                    this.nbInputs = targetValue.length;
                    this.modal = true;
                    if (!isNaN(targetValue)) {
                        if (this.nbInputs == 0) {
                            this.disabled = true;
                        }
                        if (this.nbInputs > 5) {
                            this.noResults = false;
                            this.tooLong = true;
                            return;
                        }
                    }

                    storeLocatorAutocomplete(targetValue, isAppointmentForm(event.target) ? true : false)
                        .then((cities) => {
                            (this.results as Array<City>) = cities;
                        })
                        .then(() => {
                            this.displayResults();
                        })
                        .catch((error) => {
                            console.error('Error fetching autocomplete results:', error);
                            this.results = [];
                            this.displayResultsWording = false;
                            this.noResults = true;
                        });
                }
            },
            //Store in localStorage result selected
            selectedElement(item: AutocompleteResult) {
                //Store gps position
                const selectedItem = JSON.parse(JSON.stringify(item));
                setUserDataLocalisation({ zip: selectedItem.cp, city: selectedItem.ville });
                if (item.magasin == null) {
                    removeUserShop();
                    return;
                }

                setUserDataShop(selectedItem.magasin.telephone, selectedItem.magasin.code_postal, selectedItem.magasin.ville, selectedItem.magasin.adresse, selectedItem.magasin.nom, selectedItem.magasin.code, selectedItem.magasin.url ? selectedItem.magasin.url : `${window.location.origin}/espace-conseil/?shop=${selectedItem.magasin.code}`, selectedItem.magasin.latitude, selectedItem.magasin.longitude);
            },
            setCityInBasicForm(selectedItem: SimpleAutocompleteResult, domItem: HTMLElement, index = 0) {
                try {
                    const actualForm = domItem.closest('form');
                    if (actualForm) {
                        const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');

                        if (zipInput) {
                            zipInput.value = selectedItem.codesPostaux[index];
                            this.validateField(zipInput);
                        }

                        const cityInput = actualForm.querySelector<HTMLInputElement>('[name$="[city]"]');

                        if (cityInput) {
                            cityInput.value = selectedItem.nom;
                            this.validateField(cityInput);
                        }
                    }
                } catch (e) {
                    // noop
                }
                this.closeModal();
            },
            //Faire function pour mettre la ville dans input express form
            setInfosInExpressForms(selectedItem: SimpleAutocompleteResult, domItem: HTMLElement, index = 0) {
                try {
                    const actualForm = domItem.closest('form');

                    if (actualForm) {
                        const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');

                        // Newsletter avec zip et ville splité en 2 champs
                        if (this.form?.name == 'newsletter_form') {
                            const cityInput = actualForm.querySelector<HTMLInputElement>('[name$="[city]"]');
                            if (zipInput) {
                                zipInput.value = selectedItem.codesPostaux[index];
                                this.validateField(zipInput);
                            }
                            if (cityInput) {
                                cityInput.value = selectedItem.nom;
                                this.validateField(cityInput);
                            }
                        } else {
                            if (zipInput) {
                                zipInput.value = selectedItem.codesPostaux[index] + ' ' + selectedItem.nom;
                                this.validateField(zipInput);
                            }
                        }
                    }
                } catch (e) {
                    // noop
                }
                this.closeModal();
            },
            //Display list of results
            displayResults() {
                this.results = JSON.parse(JSON.stringify(this.results));
                this.modal = true;

                if (this.results.length) {
                    this.tooLong = false;
                    this.tooShort = false;
                    this.noResults = false;
                    this.displayResultsWording = true;
                } else {
                    //No results
                    if (this.nbInputs >= 1) {
                        this.noResults = true;
                        this.tooShort = false;
                        this.tooLong = false;
                    }

                    this.displayResultsWording = false;
                }
            },
            //Open modal
            openModal() {
                this.modal = true;
                this.displayResults();
            },
            //Close modal on click outside
            closeModal() {
                this.modal = false;
            },
            selectedViaEnter(event) {
                if (this.results && this.results.length > 0) {
                    this.selectedItem = this.results[0];
                    const target = JSON.parse(JSON.stringify(this.selectedItem));
                    this.setInfosInExpressForms(this.selectedItem, event.target);
                    this.secondStepAddressZip(event.target);
                    this.modal = false;
                    event.target.blur();
                    event.target.value = `${target.cp} ${target.ville}`;
                }
            },
        };
    });
});
